import {v4 as uuidv4} from 'uuid';
import {CommandSnapshot, CommandType, UndoableCommand} from '../interfaces/command.interface';
import {generateUndoLabel, UndoLabelMetadata} from '../undo-label.utils';

export abstract class BaseCommand<T = unknown> implements UndoableCommand {
  public readonly id: string;
  public readonly timestamp: number;
  public readonly type: CommandType;
  public readonly description: string;
  public readonly labelMetadata?: UndoLabelMetadata;
  protected snapshot: CommandSnapshot<T>;

  constructor(
    type: CommandType,
    description: string,
    snapshot: CommandSnapshot<T>,
    labelMetadata?: UndoLabelMetadata
  ) {
    this.id = uuidv4();
    this.timestamp = Date.now();
    this.type = type;
    this.labelMetadata = labelMetadata;
    // If labelMetadata is provided, generate description from it; otherwise use the provided description
    this.description = labelMetadata ? generateUndoLabel(labelMetadata) : description;
    this.snapshot = snapshot;
  }

  abstract execute(): Promise<void>;

  abstract undo(): Promise<void>;

  canMerge?(other: UndoableCommand): boolean;

  merge?(other: UndoableCommand): void;

  protected getSnapshot(): CommandSnapshot<T> {
    return this.snapshot;
  }
}
